import { defineComponent as _defineComponent } from 'vue'
import * as validation from 'JS/components/blain-form/validation';
import BButtonSubmitButton from 'JS/components/blain-form/BButtonSubmitButton.vue';
import BForm from 'JS/components/blain-form/BForm.vue';
import bugsnagClient from 'JS/global/bugsnag';
import ErrorBanner from 'JS/components/ErrorBanner.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import { BPhoneNumberField } from 'Src/js/components/blain-form';
import { CreateOauthAccountRequest, ICreateAccountResponse, LoginPageType } from 'JS/types/Account';
import { IJoinRewardsStep, IVerifyUserData } from 'JS/types/rewards';
import { onMounted, ref } from 'vue';
import { RewardsReasonCode } from 'JS/types/rewards';
import { useServices } from '../../composables/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'EnterPhonePage',
  props: {
    createOauthAccountRequest: null,
    isFullScreenVersion: { type: Boolean },
    antiForgeryToken: null
  },
  emits: ["loading", "go-to-rewards", "go-to-rewards-with-oauth", "go-back"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'loading', value: boolean): void;
	(event: 'go-to-rewards', page: IJoinRewardsStep);
	(event: 'go-to-rewards-with-oauth', page: IJoinRewardsStep, data: IVerifyUserData, createOauthAccountRequest: CreateOauthAccountRequest, returnPage: LoginPageType): void;
	(event: 'go-back'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	createOauthAccountRequest: CreateOauthAccountRequest;
	isFullScreenVersion: boolean;
	antiForgeryToken: string;
}





const headerFocuser = ref<HTMLElement | null>(null);
const phoneNumber = ref<string>("");
const errorMessage = ref<string>("");

const { accountService } = useServices();

async function handleSubmitPhone() {
	try {
		emit('loading', true);
		const request: CreateOauthAccountRequest = { ...props.createOauthAccountRequest, phoneNumber: phoneNumber.value };
		const result: ICreateAccountResponse = await accountService.createOauthWithPhone(request, props.antiForgeryToken);

		if (!result?.success) {
			setCreateOauthAccountErrorMessage(result, request);
			emit('loading', false);
		} else {
			window.blainGtmDataLayer.push({
				'event': "create_login",
				'loginMethod': props.createOauthAccountRequest.loginMethod
			});
			window.blainGtmDataLayer.push({
				'event': "create_rewards"
			});
			emit('go-to-rewards', 'success');
		}

	} catch (err) {
		errorMessage.value = "Something went wrong. Please try again later.";
		emit('loading', false);
		bugsnagClient.notify(err);
	}
}

function setCreateOauthAccountErrorMessage(result: ICreateAccountResponse, request: CreateOauthAccountRequest) {
	switch (result?.reasonCode) {
		case RewardsReasonCode.REWARDS_ACCOUNT_ALREADY_LINKED:
			errorMessage.value = `<span class='bold'>This phone number is already associated with another user, ${result.email}.</span><span style='font-weight: normal'> Please enter a different number or call Customer Service at <a style='text-wrap: nowrap' class='black' href='tel:+1-800-210-2370'>1-800-210-2370</a> for help.</span>`;
			break;
		case RewardsReasonCode.REWARDS_ACCOUNT_ALREADY_EXISTS:
			emit('go-to-rewards-with-oauth',
				'verification-join',
				{ phone: result.phone, email: result.email, variant: 'verification-join', redactedData: result.redactedData },
				request,
				'enter-phone'
			);
			break;
		case RewardsReasonCode.SESSION_M_ERROR:
			bugsnagClient.notify("SessionM error occured while attempting to Join Rewards.");
		default:
			errorMessage.value = result.errorMessage;

	}
}

onMounted(()=> {
	headerFocuser.value?.focus();

	window.blainGtmDataLayer.push({
		'event': "oauth-enter-phone-page"
	});
});

return { __sfc: true,props, emit, headerFocuser, phoneNumber, errorMessage, accountService, handleSubmitPhone, setCreateOauthAccountErrorMessage, validation, BButtonSubmitButton, BForm, ErrorBanner, LinkButton, BPhoneNumberField }
}

})